import { FC } from "react";
import { styled } from "@mui/material/styles";
import MuiButton, { ButtonProps } from "@mui/material/Button";

const StyledButton = styled(MuiButton)(({ theme }) => ({
  backgroundColor: theme.colors.navy,
  border: "none",
  borderRadius: 0,
  color: theme.colors.white,
  display: "flex",
  fontFamily: theme.fonts.bold,
  fontSize: 14,
  height: 52,
  justifyContent: "space-between",
  padding: "0 24px",
  textTransform: "uppercase",
  width: 195,

  "&:hover": {
    backgroundColor: theme.colors.sapphire,
  },

  "& .MuiSvgIcon-root": {
    fontSize: 24,
  },

  "&.Mui-disabled": {
    backgroundColor: theme.colors.dimGray,
    color: theme.colors.shades[400],
    cursor: "not-allowed",
  },

  "& div": {
    transform: "translateY(2px)",
  },
}));

const Button: FC<ButtonProps> = (props) => {
  const { children, ...others } = props;
  return (
    <StyledButton disableElevation disableRipple disableTouchRipple {...others}>
      <div>{children}</div>
    </StyledButton>
  );
};

export default Button;
